import { render } from "./SVGShare.vue?vue&type=template&id=84b0a162"
import script from "./SVGShare.vue?vue&type=script&lang=js"
export * from "./SVGShare.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__